import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { __AllQualifiedUSers } from 'request/configuration/__QualifiedUsers'
import InputSelect from 'components/InputSelect/InputSelect'

/**
 * Componente para seleccionar un usuario calificado.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.valueQualifiedToUser - Valor del usuario calificado seleccionado.
 * @param {Function} props.setValueQualifiedToUser - Función para establecer el valor del usuario calificado.
 * @returns {JSX.Element} - Elemento JSX que muestra un campo de selección de usuario calificado.
 */

export const QualifiedUser = ({ get, set }) => {
  const token = useSelector(state => state.auth.dataUser.token)
  const { freeZoneValue } = useSelector(state => state.chagenFreeZone)

  const [userQualified, setUserQuialified] = useState([])

  const getUserQualified = async () => {
    try {
      const res = await __AllQualifiedUSers(token)
      const infoUsuarios = res?.data?.status?.data.map(item => ({
        value: item?.id,
        label: item?.nit_qualified + ' - ' + item?.name_qualified
      }))

      setUserQuialified(infoUsuarios)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getUserQualified()
  }, [freeZoneValue])

  return (
    <InputSelect
      tag={'Usuario calificado'}
      Name={'userQualified'}
      data={userQualified}
      set={set}
      value={get}
    />
  )
}
